import { Dispatch } from 'redux';
import streamStompMiddleware from './streamStompMiddleware';
import streamApiMiddleware from './streamApiMiddleware';

const streamServiceMiddleware =
  (store: { getState; dispatch: Dispatch }) =>
  (next: (action: any) => any) =>
  (action: any) => {
    if (process.env.REACT_APP_STREAM_SERVICE_STOMP_URL) {
      return streamStompMiddleware(store)(next)(action);
    }

    return streamApiMiddleware(store)(next)(action);
  };

export default streamServiceMiddleware;
